import React from 'react'
import { useParams } from 'react-router-dom'
import PlotData from '../../components/plots/PlotData'
import NavbarBoot from '../../components/nav/NavbarNew'
// import GraphDanzigerTS from '../../components/plots/PlotDanziger'
// import Spinner from '../components/layout/Spinner'

function PlotDews2() {
  const { duration } = useParams()
  const today = new Date()
  //const start = new Date(today)
  const start = new Date('2022-08-01T00:00:00');


  let days = 365

  if (duration != null) {
    days = duration
  }

  //start.setDate(start.getDate() - days)
  start.setDate(start.getDate() )
  today.setDate(today.getDate() + 1)

  const start_time = start.toISOString().split('T')[0] + ' 00:00:00'
  const end_time = today.toISOString().split('T')[0] + ' 00:00:00'

  return (
    <><NavbarBoot />
    <div>
      <div>
      <h2 className='bg-slate-300 text-2xl pl-5'>WMATA Tunnels</h2>
      <h6 className='bg-slate-300 text-xs pl-5 pb-2'>Temperature & Humidity</h6>

      <PlotData
        url='/api/wmata/gage/'
        gagelist={{
          primary: [
            {
              location: 'B-S_523.00',
              name: 'B-S_523.00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'B-1_498.00',
              name: 'B-1_498+00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'B-2_489.00',
              name: 'B-2_489.00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'B-1_515.00',
              name: 'B-1_515.00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'B-2_520.00',
              name: 'B-2_520.00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'B-2_524.50',
              name: 'B-2_524.50',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'B-2_534.00',
              name: 'B-2_534.00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'FG_elec',
              name: 'FG_elec',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'dew_pt',
              name: 'Surface dew pt.',
              sensortype: 'dew_pt',
              table: "weather"
            },

          ],
          secondary: [
            {
              location: 'prcp',
              name: 'Prcp',
              sensortype: 'prcp',
              table: "weather"
            },],

          y_range: [0, 70],
          title: 'B-Line Dew Point Temperatures',
        }}
        dateRange={{ dateRange: [start_time, end_time] }}
        config={{
          y_axes_range: [0.0, 100],
          y_axes_range2: [0.0, 2.0],
          y_axis_label: 'Dew Pt. Temperature (&#176;F)',
          y_axis_label2: 'Precipitation (in.)',
        }}
      />

<PlotData
url='/api/wmata/gage/'
        gagelist={{
          primary: [
            {
              location: 'A-1_293.00',
              name: 'A-1_293.00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'A-1_278.00',
              name: 'A-1_278.00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'A-1_266.00',
              name: 'A-1_266.00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'A-2_283.00',
              name: 'A-2_283.00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'A-2_294.50',
              name: 'A-2_294.50',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'A-S_264+00',
              name: 'A-S_264+00',
              sensortype: 'dewpt',
              table: "leap_th2_location"
            },
            {
              location: 'A-S_297+00',
              name: 'A-S_297+00',
              sensortype: 'tedewptmperature',
              table: "leap_th2_location"
            },
            {
              location: 'A-S_298.50',
              name: 'A-S_298.50',
              sensortype: 'dewpt',
              table: "leap_th1_location"
            },
            {
              location: 'A-S_265.00',
              name: 'A-S_265.00',
              sensortype: 'dewpt',
              table: "leap_th1_location"
            },
            {
              location: 'dew_pt',
              name: 'Surface dew pt.',
              sensortype: 'dew_pt',
              table: "weather"
            },

          ],
          secondary: [
            {
              location: 'prcp',
              name: 'Prcp',
              sensortype: 'prcp',
              table: "weather"
            },],

          y_range: [0, 70],
          title: 'A-Line Dew Point Temperatures',
        }}
        dateRange={{ dateRange: [start_time, end_time] }}
        config={{
          y_axes_range: [0.0, 100],
          y_axes_range2: [0.0, 2.0],
          y_axis_label: 'Dew Pt. Temperature (&#176;F)',
          y_axis_label2: 'Precipitation (in.)',
        }}
      />
      <h6 className='bg-slate-300 text-xs pl-5 pt-2 pb-2'> Wetness</h6>
  <PlotData
  url='/api/wmata/gage/'
        gagelist={{
          primary: [
            {
              location: 'B-1_498.01',
              name: 'B-1_498.01',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },
            {
              location: 'B-1_528.00',
              name: 'B-1_528.00',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },
            
            {
              location: 'B-2_520.00',
              name: 'B-2_520.00',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },
            {
              location: 'B-2_523.50',
              name: 'B-2_523.50',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },
            {
              location: 'B-2_531.00',
              name: 'B-2_531.00',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },
            {
              location: 'B-2_534.00',
              name: 'B-2_534.00',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },

          ],
          secondary: [
            {
              location: 'prcp',
              name: 'Prcp',
              sensortype: 'prcp',
              table: "weather"
            },],

          y_range: [0, 70],
          title: 'B-Line Wetness',
        }}
        dateRange={{ dateRange: [start_time, end_time] }}
        config={{
          y_axes_range: [0.0, 100],
          y_axes_range2: [0.0, 2.0],
          y_axis_label: 'Wetness (%)',
          y_axis_label2: 'Precipitation (in.)',
        }}
        />

<PlotData
url='/api/wmata/gage/'
        gagelist={{
          primary: [
            {
              location: 'A-1_293.00',
              name: 'A-1_293.00',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },
            {
              location: 'A-1_281.00',
              name: 'A-1_281.00',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },
            {
              location: 'A-2_290.00',
              name: 'A-2_290.00',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },
            {
              location: 'A-2_286.00',
              name: 'A-2_286.00',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },
            {
              location: 'A-2_294.50',
              name: 'A-2_294.50',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },
            {
              location: 'A-S_277.00',
              name: 'A-S_277.00',
              sensortype: 'wetness',
              table: "leap_wet_location"
            },

          ],
          secondary: [
            {
              location: 'prcp',
              name: 'Prcp',
              sensortype: 'prcp',
              table: "weather"
            },],

          y_range: [0, 70],

          title: 'A-Line Wetness',
        }}
        dateRange={{ dateRange: [start_time, end_time] }}
        config={{
          y_axes_range: [0.0, 100],
          y_axes_range2: [0.0, 2.0],
          y_axis_label: 'Wetness (%)',
          y_axis_label2: 'Precipitation (in.)',
        }}
        />


    </div>
    
    </div></>
  )
}

export default PlotDews2
